import styled from 'styled-components/macro'
import { ifProp } from 'styled-tools'
import { color, rgba } from '../../../utils/styles'

const FieldHelp = styled.p`
  margin: .5em 0 0;
  font-size: .75em;
  color: ${ifProp('error', color('error'), rgba('base', 0.4))};
`

export default FieldHelp
